import { Navigate, Route, Routes } from "react-router-dom";
import { ASSETS } from "../config/assets";
import { getBusinessFeatureRoutes } from "../utils/businessRoutes";
import { getPostLoginPath } from "../utils/auth";

import Unauthorized from "../components/Unauthorized";
import BusinessLayout from "../components/business/BusinessLayout";
import FeaturePage from "../components/business/FeaturePage";
import BusinessDashboardHome from "../components/business/BusinessDashboardHome";
import LiveChat from "../components/business/LiveChat";
import LiveChatSettings from "../components/business/LiveChatSettings";
import History from "../components/business/History";
import SendTestMessage from "../components/business/SendTestMessage";
import Contacts from "../components/business/Contacts";
import ArchivedContacts from "../components/business/ArchivedContacts";
import FetchingAllCampaign from "../components/business/FetchingAllCampaign";
import CampaignDetail from "../components/business/CampaignDetail";
import CampaignStatusDetail from "../components/business/CampaignStatusDetail";
import AllSmsTemplate from "../components/business/AllSmsTemplate";
import AllTeams from "../components/business/AllTeams";
import CreateTeams from "../components/business/CreateTeams";
import ApiCampaign from "../components/business/ApiCampaign";
import BroadcastCampaign from "../components/business/BroadcastCampaign";
import ExcelCampaign from "../components/business/ExcelCampaign";
import CampaignV2 from "../components/business/CampaignV2";
import WebhookSubscribe from "../components/business/WebhookSubscribe";
import ChatbotAI from "../components/business/chatbotai";
import WhatsAppWidgetButton from "../components/WhatsAppWidgetButton";
import ApiKeyGenerate from "../components/business/ApiKeyGenerate";
import AgentActivity from "../components/business/AgentActivity";
import ChangePassword from "../components/business/ChangePassword";
import DialogflowCredentials from "../components/business/DialogflowCredentials";
import FetchAllCannedMessage from "../components/business/FetchAllCannedMessage";
import CreateCannedMessage from "../components/business/CreateCannedMessage";
import FetchAllTags from "../components/business/FetchAllTags";
import CreateTag from "../components/business/CreateTag";
import Attribute from "../components/business/Attribute";
import FetchAllTemplates from "../components/business/FetchAllTemplates";
import CreateTemplate from "../components/business/CreateTemplate";
import WhatsappForm from "../components/business/WhatsappForm";
import SmsConfig from "../components/business/SmsConfig";
import GoogleFormConfig from "../components/business/GoogleFormConfig";
import GoogleSheetConfig from "../components/business/GoogleSheetConfig";
import GoogleOauthCallback from "../components/business/GoogleOauthCallback";
import MyProfile from "../components/business/MyProfile";
import OptInOutManagement from "../components/business/OptInOutManagement";
import Payments from "../components/business/Payments";
import PaymentSetup from "../components/business/PaymentSetup";
import TeamRoles from "../components/business/TeamRoles";
import CreateTeamRole from "../components/business/CreateTeamRole";
import TemplateLibrary from "../components/business/TemplateLibrary";
import Analytics from "../components/Analytics";
import Plans from "../components/business/Plans";

const PROJECT_PAGES = [
  { path: "dashboard", element: <BusinessDashboardHome /> },
  { path: "livechat", element: <LiveChat /> },
  { path: "livechatsettings", element: <LiveChatSettings /> },
  { path: "history", element: <History /> },
  { path: "sendtestmessage", element: <SendTestMessage /> },
  { path: "contacts", element: <Contacts /> },
  { path: "archivedcontacts", element: <ArchivedContacts /> },
  { path: "fetchingallcampaign", element: <FetchingAllCampaign /> },
  { path: "allsmstemplate", element: <AllSmsTemplate /> },
  { path: "allteams", element: <AllTeams /> },
  { path: "create-teams", element: <CreateTeams /> },
  { path: "apicampaign", element: <ApiCampaign /> },
  { path: "broadcastCampaign", element: <BroadcastCampaign /> },
  { path: "campaign/:campaignId/:status", element: <CampaignStatusDetail /> },
  { path: "campaign/:campaignId", element: <CampaignDetail /> },
  { path: "campaign", element: <ExcelCampaign /> },
  { path: "campaignv2", element: <CampaignV2 /> },
  { path: "whatsapp+sms_campaign", element: <CampaignV2 /> },
  { path: "webhookSubscribe", element: <WebhookSubscribe /> },
  { path: "chatbot", element: <ChatbotAI /> },
  { path: "chatbotai", element: <ChatbotAI /> },
  { path: "whatsappflow", element: <ChatbotAI /> },
  { path: "apikeygenerate", element: <ApiKeyGenerate /> },
  { path: "agentactivity", element: <AgentActivity /> },
  { path: "changepassword", element: <ChangePassword /> },
  { path: "dialogflowcredentials", element: <DialogflowCredentials /> },
  { path: "fetchallcannedmessage", element: <FetchAllCannedMessage /> },
  { path: "create-canned-message", element: <CreateCannedMessage /> },
  { path: "fetchalltags", element: <FetchAllTags /> },
  { path: "createtag", element: <CreateTag /> },
  { path: "attribute", element: <Attribute /> },
  { path: "fetchalltemplates", element: <FetchAllTemplates /> },
  { path: "createtemplate", element: <CreateTemplate /> },
  { path: "flows", element: <WhatsappForm /> },
  { path: "whatsappform", element: <WhatsappForm /> },
  { path: "smsconfig", element: <SmsConfig /> },
  { path: "googlesheetintegration", element: <GoogleSheetConfig /> },
  { path: "googleformconfig", element: <GoogleFormConfig /> },
  { path: "googleoauthcallback", element: <GoogleOauthCallback /> },
  { path: "myprofile", element: <MyProfile /> },
  { path: "optin-outmanagement", element: <OptInOutManagement /> },
  { path: "payments", element: <Payments /> },
  { path: "paymentsetup", element: <PaymentSetup /> },
  { path: "teamroles", element: <TeamRoles /> },
  { path: "create-teamsrole", element: <CreateTeamRole /> },
  { path: "templatelib", element: <TemplateLibrary /> },
  { path: "waba_analytics", element: <Analytics /> },
  { path: "plans", element: <Plans /> },
  { path: "whatsapp-widget-button", element: <WhatsAppWidgetButton /> },
];

const implementedPaths = new Set(PROJECT_PAGES.map((page) => page.path));

function extraMenuPages() {
  return getBusinessFeatureRoutes()
    .filter(({ path }) => !implementedPaths.has(path))
    .map(({ path, label }) => (
      <Route
        key={path}
        path={path}
        element={
          <FeaturePage
            title={label}
            description={`${ASSETS.brandName} · ${label}`}
          />
        }
      />
    ));
}

/** Project workspace: /businessprojects/:projectId/... */
export default function BusinessApp() {
  return (
    <div className="App">
      <Routes>
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/businessprojects/:projectId" element={<BusinessLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          {PROJECT_PAGES.map((page) => (
            <Route key={page.path} path={page.path} element={page.element} />
          ))}
          {extraMenuPages()}
        </Route>
        <Route path="*" element={<Navigate to={getPostLoginPath()} replace />} />
      </Routes>
    </div>
  );
}
